<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Package Group Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="test_package_group.name" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <test-package-group-card
      v-if="test_package_group"
      :test_package_group="test_package_group"
    />
  </div>
</template>
<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import TestPackageGroupCard from "@/components/lab/testpackagegroup/TestPackageGroupCard";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { getModel } from "@/shared/fetch-utils";

export default {
  name: "TestPackageGroupDetail",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    TestPackageGroupCard,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/testpackagegroups",
            title: "Test package group list",
          },
          {
            icon: "fa-pencil",
            linkto: `/testpackagegroups/${this.test_package_group_id}/edit`,
            title: "Edit test package group",
            variant: "warning",
            permission: this.checkPermission("edit test package group"),
          },
        ],
      };
    },
  },
  data() {
    return {
      loading: true,
      test_package_group_id: this.$route.params.test_package_group_id || null,
      test_package_group: null,
    };
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
  },
  async created() {
    this.loading = true;

    this.test_package_group = await getModel({
      model_type: "test_package_group",
      id: this.test_package_group_id,
      message: this.$bvToast,
    });

    this.test_package_group ? (this.loading = false) : this.$router.back();
  },
};
</script>
